package ui.pages

import event.EventDate
import event.EventHandler
import react.FC
import react.ReactNode
import react.Suspense
import react.create
import react.dom.html.ReactHTML
import ru.malygin.myConst.SelectedCategory
import ui.component.external.*
import ui.styles.Styles
import ui.styles.icons.BlurOnRoundedIconSVG
import ui.themePlusContext.useMainContext
import utils.logger.log

val Page = FC {

    val ctx = useMainContext()

    EventHandler.launchEventInit{
        this.pushEvent = EventDate.NO_EVENT
    }

    NewDialog{
        dialogData = NewDialogData(
            dialogInfo = NewDialogEnum.ON_START_DIALOG,
            titleText = "⚠\uFE0F Внимание ⚠\uFE0F"
        )
        startByCreate = ctx.category == SelectedCategory.NONE
        closeable = false
    }

    Suspense{
        this.fallback = ReactNode('s')
        DrawerUnit()
    }

    ReactHTML.div{
        className = Styles.Page.pageBox

        Suspense{
            Header()
        }

        Suspense{
            this.fallback = FC{
                ReactHTML.span{
                    +"Loading..."
                }
            }.create()

            Content()
        }

//        Footer()
    }
}